import stbApiGateway from '@/services/stbApiGateway';
import * as types from '../../../mutationTypes';

export const createExcursion = async (
  { state, commit },
  { name, type, startDate, endDate, oauthSignature }
) => {
  const stbApi = stbApiGateway(state.axios);
  const response = await stbApi.postExcursions(name, type, startDate, endDate, oauthSignature);
  if (response.data) {
    commit(types.SET_EXCURSION_ID, response.data.id);
  }
  return response.data?.computed?.query['oauth-signature'];
};
